<template>
    <div class="principal">
		<img v-if="primeiroAcesso==false" src="../assets/Prancheta_1.1.3.png" style="width: 100%;" />
		<img v-if="primeiroAcesso && (idPerfilPortal==3 || idPerfilPortal==7)" src="" style="width: 80%;" />
		<img v-if="primeiroAcesso && idPerfilPortal==4" src="" style="width: 80%;" />
    </div>
</template>

<script>
import PortalCredencialWebApi from "@/API/PortalCredencialWebApi";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";

export default {
	name: "principal",
    data() {
		return {
			data: [],
			primeiroAcesso: false,
			idPerfilPortal: 0,
		};
	},
	mounted() {
		this.primeiroAcesso = this.$store.state.auth.primeiroAcesso;
		this.idPerfilPortal = this.$store.state.auth.idPerfilPortal;
	},
	methods: {
    }
}
</script>

<style scoped>

</style>
